import React from 'react';

const FieldContainer = (props) => {
    return <>
        <style>
            {
                `
                    .form-field-container {
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: ${props.dense ? '1rem' : '3rem'};
                        margin-bottom: ${props.dense ? '0.5rem' : '3rem'};
                        padding-bottom: ${props.dense ? '0' : '2.5rem'};
                        border-bottom: ${props.dense ? 'none' : '1px solid #f0f0f0'};
                    }
                    .form-field-container:last-of-type {
                        border-bottom: none;
                    }

                    .form-field-container__required-field-indicator {
                        color: red;
                        margin-left: 0.25rem;
                    }
                `
            }
        </style>
        <div
        className="form-field-container"
    >
        <div
            style={
                {
                    paddingRight: '3rem',
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexBasis: props.wrap ? 'auto' : '19rem',
                    flexGrow: 1,
                    flexShrink: 1,
                    marginTop: '0.5rem',
                    fontWeight: '500',
                    width: '100%',
                    overflow: 'hidden'
                }
            }
        >
            {props.label}
        </div>
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    flexBasis: props.wrap ? 'auto' : '28rem',
                    flexGrow: 1,
                    flexShrink: 1,
                }
            }
        >
            {props.control}
        </div>
    </div>
        </>
}

export default FieldContainer;
